import React, { CSSProperties, ReactNode } from 'react';
import { CheckCircle, Clock, ListTodo } from 'lucide-react';
import RefreshButton from '../../../components/main/RefreshButton/RefreshButton';
import { RequestStateEnum, usePendingRequestsCountQuery, useRequestsCountQuery } from '../../../generated/graphql';

type DashboardProps = {
    style?: CSSProperties;
    children?: ReactNode;
    className?: string;
};

const Dashboard = ({ style }: DashboardProps) => {
    const openResult = usePendingRequestsCountQuery();
    const closedResult = useRequestsCountQuery({ variables: { state: RequestStateEnum.Closed } });
    const totalResult = useRequestsCountQuery();

    const handleRefresh = () => {
        openResult.refetch();
        closedResult.refetch();
        totalResult.refetch();
    };

    const stats = [
        { label: 'Open Requests', value: openResult.data?.PendingRequestsCount, icon: Clock, color: 'var(--text-primary)', bgColor: 'var(--data-yellow-soft)' },
        { label: 'Closed Requests', value: closedResult.data?.RequestsCount, icon: CheckCircle, color: 'var(--data-green)', bgColor: 'var(--data-green-soft)' },
        { label: 'All Requests', value: totalResult.data?.RequestsCount, icon: ListTodo, color: 'var(--data-blue)', bgColor: 'var(--data-blue-soft)' },
    ];

    return (
        <div className="page-container" style={{ ...style, overflowY: 'auto' }} data-testid="GovernanceDashboard">
            <div className="page-header">
                <div>
                    <h1 className="page-title">Dashboard</h1>
                    <p className="page-subtitle">Content request overview</p>
                </div>
                <RefreshButton onRefresh={handleRefresh} className="btn-secondary" iconSize={16} />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 animate-slide-up">
                {stats.map((stat) => {
                    const Icon = stat.icon;
                    return (
                        <div key={stat.label} className="card p-5">
                            <div className="w-10 h-10 rounded-xl flex items-center justify-center mb-4" style={{ backgroundColor: stat.bgColor }}>
                                <Icon size={20} style={{ color: stat.color }} />
                            </div>
                            <div className="stat-value">{stat.value != null ? stat.value.toLocaleString() : '—'}</div>
                            <div className="stat-label mt-1">{stat.label}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Dashboard;
